import React from 'react';
import CallToAction from '../components/CallToAction';
import Specials from '../components/Specials';
import CustomersSay from '../components/CustomersSay';
import Chicago from '../components/Chicago';



function Main () {

    return (

        <>
            <CallToAction />
            <Specials />
            <CustomersSay />
            <Chicago />
        </>
    )

}

export default Main;